{
  "dsn": "https://5b7d050b1be34d7eb1e8f6d6d92447ff@o475413.ingest.sentry.io/5521975",
  "release": "bulkportal-app-8460d07631fd97ff7c5212c7277041c3746f155f"
}
